import initialState from './initialState';
import { reducer as collectionsWithPromptReducer } from './collectionsWithPrompt';
import { reducer as createBulkCollectionsReducer } from './createBulkCollections';
import { reducer as createAppReducer } from './createApp';
import { reducer as addRolesAndUsersReducer } from './addRolesAndUsers';
import { reducer as fetchPagesReducer } from './fetchPages';
import { reducer as generateHtmlForPagesReducer } from './generateHtmlForPages';
import { reducer as createPageReducer } from './createPage';
import { reducer as figmaTokenSubmitReducer } from './figmaTokenSubmit';
import { reducer as fetchTokenDetailsReducer } from './fetchTokenDetails';
import { reducer as fetchFigmaImageReducer } from './fetchFigmaImage';
import { reducer as generateDefaultLayoutsReducer } from './generateDefaultLayouts';
import { reducer as generateFigmaLayoutsReducer } from './generateFigmaLayouts';
import { reducer as generateImageLayoutsReducer } from './generateImageLayouts';
import { reducer as updateLinkingToUuidReducer } from './updateLinkingToUuid';

const reducers = [
  collectionsWithPromptReducer,
  createBulkCollectionsReducer,
  createAppReducer,
  addRolesAndUsersReducer,
  figmaTokenSubmitReducer,
  fetchTokenDetailsReducer,
  fetchFigmaImageReducer,
  fetchPagesReducer,
  generateHtmlForPagesReducer,
  createPageReducer,
  generateDefaultLayoutsReducer,
  generateFigmaLayoutsReducer,
  generateImageLayoutsReducer,
  updateLinkingToUuidReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
